import React, { useState } from 'react';
import { useParams } from 'react-router';

import createForm from '@swf/components/Forms/Form';
import Input from '@swf/components/Inputs/Input';
import StarsButton from '@swf/components/StarsButton/StarsButton';
import Translation from '@swf/components/Translation/Translation';
import { UserClubRole } from '@swf/core/types/Poker';
import {
  FormattedUTCDate,
  PKR_RESTRICTED_SYMBOLS,
  PKR_RESTRICTED_SYMBOLS_STRING,
  mustNotContainSymbols,
  useGetCurrentClub
} from '@swf/poker';

import {
  TXTCLI_Announcement_Whiteboard,
  TXTCLI_Send,
  TXTWCL_The_following_characters_are_i_ELL
} from './Announcements.messages.json';
import styles from './Announcements.scss';
import useAnnouncementStream from './hooks/useAnnouncementStream';
import useClubMessageRequest from './hooks/useClubMessageRequest';

export interface FormFields {
  announcement: string;
}

const Form = createForm<FormFields>();

const Announcements: React.FC = () => {
  const { clubId } = useParams<{ clubId: string }>();
  const [loading, setLoading] = useState(false);
  const { state } = useAnnouncementStream({ clubId });
  const { handleSubmit } = useClubMessageRequest({ clubId, setLoading });
  const { roleForUser } = useGetCurrentClub(clubId);

  return (
    <div className={styles.container}>
      <h3 className={styles.heading}>
        <Translation {...TXTCLI_Announcement_Whiteboard} />
      </h3>
      {state && (
        <>
          <div className={styles.date}>
            <b>{state.userId}</b>
            <FormattedUTCDate
              utcDate={`${state.created}`}
              options={{ isRelative: true, dateStyle: 'long', timeStyle: 'short' }}
            />
          </div>
          <div className={styles.announcement}>{state.content}</div>
        </>
      )}
      {(roleForUser === UserClubRole.Manager || roleForUser === UserClubRole.Admin) && (
        <Form
          className={styles.form}
          onSubmit={handleSubmit}
          initialValues={{ announcement: '' }}
          render={({ values: { announcement } }) => {
            const value = announcement ?? '';
            const isEmpty = value.replace(/ /g, '') === '';
            return (
              <>
                <Input
                  id="announcement"
                  label=""
                  showValidationTick={false}
                  type="textarea"
                  validators={[
                    mustNotContainSymbols(PKR_RESTRICTED_SYMBOLS, {
                      ...TXTWCL_The_following_characters_are_i_ELL,
                      values: { 0: PKR_RESTRICTED_SYMBOLS_STRING }
                    })
                  ]}
                />
                <StarsButton
                  block
                  disabled={loading || isEmpty}
                  type="submit"
                  translation={TXTCLI_Send}
                />
              </>
            );
          }}
        />
      )}
    </div>
  );
};

export default Announcements;
